import {observer} from "mobx-react";
import {CreditText} from "../../../models/CreditText";
import {Box, CircularProgress, IconButton, InputAdornment, TextField} from "@mui/material";
import {KeyboardArrowUp, KeyboardArrowDown} from "@mui/icons-material";
import {useStore} from "../../../stores/Store";
import React, {useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";

interface Props {
    creditText: CreditText
}

export default observer(({creditText}: Props) => {
    const { CreditTextsStore } = useStore();
    const { isCreditTextLoading, update, del, creditTexts, updateOrder } = CreditTextsStore;
    const [text, setText] = useState<CreditText>(creditText);

    const handleChangeText = (event: any) => {
        setText({...text, text: event.target.value})
    }

    const handleUpdate = () => {
        if(text.text === creditText.text && text.order === creditText.order) return;
        update(text);
    }

    return (
        <Box sx={{display:'flex', width: '100%', justifyContent: 'center', mt: 2}}>
            <Box sx={{alignItems: 'center', display: 'flex', mr: 0.5}}>
                <IconButton
                    disabled={text.order === creditTexts.length}
                    onClick={() => updateOrder(text, 1)}
                >
                    <KeyboardArrowDown />
                </IconButton>
            </Box>
            <TextField
                sx={{width: '90%'}}
                value={text.text}
                label={text.order}
                InputProps={{
                    endAdornment: <InputAdornment position="end">
                        { isCreditTextLoading(creditText.id) ?
                            <CircularProgress color={'secondary'} size={16} sx={{mr: 2}}/> :
                            <IconButton
                                size={'small'}
                                onClick={() => del(creditText.id)}
                                color={'error'}
                            >
                                <DeleteIcon />
                            </IconButton>
                        }
                    </InputAdornment>,
                }}
                onChange={handleChangeText}
                onBlur={handleUpdate}
                onKeyUp={(event: any) => { if(event.keyCode === 13) handleUpdate()  }}
            />
            <Box sx={{alignItems: 'center', display: 'flex', ml: 0.5}}>
                <IconButton
                    disabled={text.order === 1}
                    onClick={() => updateOrder(text, -1)}
                >
                    <KeyboardArrowUp />
                </IconButton>
            </Box>
        </Box>
    )
})